<p>{{ messageKey | translate }}</p>
<div class="btn-container">
  <input type="submit" class="cb-btn no-padding" value="{{'COMMON.NO' | translate}}" (click)="cancel()"/>
  <input type="submit" class="cb-btn" value="{{'COMMON.YES' | translate}}" (click)="yes()"/>
</div>
